import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {Navbar} from "../cmps/Layout/Navbar/Navbar";
import "./App.css";
import {useDispatch, connect} from "react-redux";
import {useEffect, useState} from "react";
import Routes from "../cmps/Routing/Routes";
import {AuthGState, AuthActions, darkTheme, Spinner, theme, useFavoriteTheme, Footer, CssBaseline, ThemeProvider, Box} from "@leap4/frontend";
import {GlobalState} from "../types/globalStateType";
import "../assets/styles/global.scss"

const mapStateToProps = (state: Partial<GlobalState>) => ({
    auth: state.auth,
});

const connector = connect(mapStateToProps)

function App(props: Partial<GlobalState>) {
    const auth: AuthGState | any = props.auth
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(true)
    const [selectedTheme, setSelectedTheme] = useFavoriteTheme();

    useEffect(() => {
        (async () => {
                try {
                    await AuthActions.loadUser(dispatch, process.env.REACT_APP_SERVICE_NAME || "", `${process.env.REACT_APP_BACKEND_BASE_URL}/app/me`)
                } finally {
                    setIsLoading(false)
                }
            }
        )();
    }, []);


    if (isLoading) {
        return <Spinner/>
    }

    const handleCheckChange = (checked:boolean)=>{
        const themeToShow = checked ? theme : darkTheme;
        setSelectedTheme(themeToShow)
    }

    return (
        <>
            <ThemeProvider theme={selectedTheme}>
                <Box sx={{ display: "flex", flexDirection: 'column', minHeight: '100vh' }}>
                    <CssBaseline/>

                    <Router>
                        {auth.user && <Navbar handleCheckChange={(checked:boolean)=>handleCheckChange(checked)}  />}
                        <Box component="main" sx={{ flexGrow: 1, paddingTop: '20px', width: "100%", marginBottom: "auto" }}>
                            <Box sx={(theme) => ({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: '0 15px', ...theme?.mixins?.toolbar })} />

                            <Switch>
                                <Route component={Routes}/>
                            </Switch>
                        </Box>
                    </Router>
                </Box>
                <Footer footerBgc='#343a40'
                        footerColor='white'
                        text='Tasks Management'
                        logoUrl='https://cdn1.iconfinder.com/data/icons/education-2-1/256/School_Test-256.png'/>
            </ThemeProvider>

        </>
    );
}

export default connector(App);
